import AdminLayout from "../../commponents/layout/adminLayout";
import ProductForm from "../../commponents/product/productForm";
import ProductImages from "../../commponents/product/productImages";
import { createProduct } from "../../api/productApi";
import { useEffect, useState } from "react";
import type { ImageItem } from "../../type/product";
import { getCategory } from "../../api/categoryApi";
import { getSubCategoryByCategory } from "../../api/subCategoryApi";
import { showError, showSuccess } from "../../utils/ alert";
import { useNavigate } from "react-router-dom";

interface Category {
  id: number;
  categoryName: string;
}

interface SubCategory {
  id: number;
  subCategoryname: string;
}

export default function AddProduct() {

  const navigate = useNavigate();

  const [name, setName] = useState("");

  const [categoryId, setCategoryId] = useState(0);

  const [subCategoryId, setSubCategoryId] = useState(0);

  const [isActive, setIsActive] = useState(true);

  const [descriptions, setDescriptions] = useState([
    {
      type: "",
      standardMaterial: "",
      pressure: "",
      temperature: "",
      surfaceSpeed: "",
      stock: 0,
      unlimited: false,
    },
  ]);

  const [categories, setCategory] = useState<Category[]>([]);
  const [subCategories, setSubCategories] = useState<SubCategory[]>([]);



 const [productImages, setProductImages] = useState<ImageItem[]>([]);
 const [productDemoImages, setProductDemoImages] = useState<ImageItem[]>([]);

  const handleSubmit = async () => {
    try {
      const formData = new FormData();

      formData.append("name", name);
      formData.append("categoryId", String(categoryId));
      formData.append("subCategoryId", String(subCategoryId));
      formData.append("isActive", String(isActive));

      formData.append("descriptions", JSON.stringify(descriptions));

      productImages.forEach((item) => {
        if (item instanceof File) {
          formData.append("productImages", item);
        }
      });

       productDemoImages.forEach((item) => {
         if (item instanceof File) {
           formData.append("productDemoImages", item);
         }
       });

  
      await createProduct(formData);

      await showSuccess("Product created successfully");
      navigate("/product");
    } catch (error) {
  
      showError("Failed to create product");
    }
  };

  const handleRemoveProductImage = (item: ImageItem) => {
    setProductImages((prev) => prev.filter((img) => img !== item));
  };

  const handleRemoveDemoImage = (item: ImageItem) => {
    setProductDemoImages((prev) => prev.filter((img) => img !== item));
  };

    const fetchCategory = async () => {
      try {
  
    
        const response = await getCategory({
          page: 1,
          limit: 10,
        });
    
        setCategory(response.data.categoryList);
    
      } catch (error) {
        showError(
        "Failed",
        "Failed to Load data."
    );
      } finally {
    
      }
    };
  
  const fetchSubCategories = async (categoryId: number) => {
    try {
      const response = await getSubCategoryByCategory(categoryId);

      setSubCategories(response.data.data.subCategoryList);

    
    } catch (error) {
      showError(
        "Failed",
        "Failed to Load data."
    );
    }
  };
    
    useEffect(() => {
      fetchCategory();
    }, []);
  
  useEffect(() => {
    if (!categoryId) {
      setSubCategories([]);
      return;
    }

    fetchSubCategories(categoryId);
  }, [categoryId]);

    
   const handleCancel = () => navigate("/product");
  return (
    <AdminLayout>
      <div className="rounded-[32px] bg-white p-8">
        <h1 className="mb-10 text-3xl font-bold text-gray-900">Add Product</h1>

        <div className="grid grid-cols-12 gap-12">
          {/* Left */}
          <div className="col-span-7">
            <ProductForm
              name={name}
              setName={setName}
              categories={categories}
              subCategories={subCategories}
              categoryId={categoryId}
              setCategoryId={setCategoryId}
              subCategoryId={subCategoryId}
              setSubCategoryId={setSubCategoryId}
              isActive={isActive}
              setIsActive={setIsActive}
              descriptions={descriptions}
              setDescriptions={setDescriptions}
            />
          </div>

          {/* Right */}
          <div className="col-span-5">
            <ProductImages
              productImages={productImages}
              setProductImages={setProductImages}
              productDemoImages={productDemoImages}
              setProductDemoImages={setProductDemoImages}
              onRemoveProductImage={handleRemoveProductImage}
              onRemoveDemoImage={handleRemoveDemoImage}
            />
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12 flex justify-end gap-4">
          <button
            type="button"
            onClick={handleCancel}
            className="rounded-lg bg-red-600 px-8 py-3 font-semibold text-white transition hover:bg-red-700">
            Cancel
          </button>

          <button
            type="button"
            onClick={handleSubmit}
            className="rounded-lg bg-green-600 px-8 py-3 font-semibold text-white transition hover:bg-green-700">
            Submit
          </button>
        </div>
      </div>
    </AdminLayout>
  );
}
